/* eslint-disable react/destructuring-assignment */
import React from "react";
import { useSelector } from "react-redux";
import {
  hasDoneActivitiesByMonthStackedBarChartAccess,
  hasLawsuitCounterAccess,
  hasLawsuitUpdatesCounterAccess,
  hasDoneActivitiesByResponsibleLineChartAccess,
  hasInProgressActivitiesByResponsibleStackedColumnChartAccess,
} from "./selectors/powersSelectors";

import DoneActivitiesByMonthStackedBarChart from "./charts/calendar/DoneActivitiesByMonthStackedBarChart";
import DoneActivitiesByResponsibleLineChart from "./charts/calendar/DoneActivitiesByResponsibleLineChart";
import { InProgressActivitiesByResponsibleStackedColumnChart } from "./charts/calendar/InProgressActivitiesByResponsibleStackedColumnChart";
import LawsuitCounter from "./charts/lawsuit/LawsuitCounter";
import LawsuitUpdatesCounter from "./charts/lawsuit/LawsuitUpdatesCounter";
import { ChartSectionWrapper, DashboardCol, TabWrapper } from "./style";

const DashboardSingleSection = () => {
  const shouldRender = {
    doneActivitiesByMonthStackedBarChart: useSelector(
      hasDoneActivitiesByMonthStackedBarChartAccess
    ),
    doneActivitiesByResponsibleLineChart: useSelector(
      hasDoneActivitiesByResponsibleLineChartAccess
    ),
    inProgressActivitiesByResponsibleStackedColumnChart: useSelector(
      hasInProgressActivitiesByResponsibleStackedColumnChartAccess
    ),
    lawsuitUpdatesCounter: useSelector(hasLawsuitUpdatesCounterAccess),
    lawsuitCounter: useSelector(hasLawsuitCounterAccess),
  };

  return (
    <TabWrapper>
      <ChartSectionWrapper>
        {shouldRender.lawsuitUpdatesCounter && (
          <DashboardCol xs={12} sm={12} md={12} lg={6}>
            <LawsuitUpdatesCounter />
          </DashboardCol>
        )}
        {shouldRender.lawsuitCounter && (
          <DashboardCol xs={12} sm={12} md={12} lg={6}>
            <LawsuitCounter />
          </DashboardCol>
        )}
        {shouldRender.doneActivitiesByMonthStackedBarChart && (
          <DashboardCol xs={12} sm={12} md={12} lg={12}>
            <DoneActivitiesByMonthStackedBarChart />
          </DashboardCol>
        )}
        {shouldRender.inProgressActivitiesByResponsibleStackedColumnChart && (
          <DashboardCol xs={12} sm={12} md={12} lg={12} xl={6}>
            <InProgressActivitiesByResponsibleStackedColumnChart />
          </DashboardCol>
        )}
        {shouldRender.doneActivitiesByResponsibleLineChart && (
          <DashboardCol xs={12} sm={12} md={12} lg={12} xl={6}>
            <DoneActivitiesByResponsibleLineChart />
          </DashboardCol>
        )}
      </ChartSectionWrapper>
    </TabWrapper>
  );
};

export default DashboardSingleSection;
